import React, { Component } from 'react';
import "../../assets/css/login.css"
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
// Language translate import
import { withTranslation } from 'react-i18next';
// Connect react and redux
import { connect } from 'react-redux';
// Action call from redux
import { bankdIdUserInfo } from '../../redux/actions/UserActions';
// Images
import Loading from '../Loader/Loader';
import ErrorPage from '../Error/ErrorPage';
import { surveyOnLogin } from '../../utils/restriction';
class BankIdLoginRedirect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            error: "",
            portallogo: localStorage.getItem("publicportallogo")
        }
    }

    componentDidMount() {
        const logincv = localStorage.getItem('logincv');
        const urlParams = this.props.location.search;
        if (urlParams) {
            const accessTokenParam = new URLSearchParams(urlParams);
            if (accessTokenParam) {
                const requestParams = {
                    code: accessTokenParam.get('code'),
                    CodeVerifier: logincv
                }
                this.props.bankdIdUserInfo(requestParams);
            }
            else {
                this.props.history.push('/')
            }
        } else {
            this.props.history.push('/')
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userinformation !== this.props.userinformation && Object.keys(this.props.userinformation).length > 0) {
            const userInformation = this.props.userinformation;
            if (userInformation.Success) {
                if (userInformation.Result.isClientAuthenticated) {
                    if (userInformation.Result.isOnboardingRequired) {
                        this.props.history.push({
                            pathname: '/OnBoarding',
                            state: {
                                email: userInformation.Result.email,
                                phoneNumber: userInformation.Result.phone_number,
                                name: userInformation.Result.name
                            }
                        });
                    } else {
                        if (userInformation.Result.survey !== null) {
                            surveyOnLogin(this.props, userInformation.Result.survey.surveyId);
                            return;
                        }
                        const previousPath = sessionStorage.getItem("PreviousPath");
                        this.props.history.push(previousPath ? previousPath : '/Dashboard');
                    }
                } else {
                    if (userInformation.Result.survey !== null) {
                        surveyOnLogin(this.props, userInformation.Result.survey.surveyId);
                        return;
                    }
                    const previousPath = sessionStorage.getItem("PreviousPath");
                    this.props.history.push(previousPath ? previousPath : '/Dashboard');
                }
            } else {
                this.setState({
                    error: this.props.t('loginRedirect.errorText')
                });
            }
        }
    }


    render() {
        if (this.props.error) {
            return <ErrorPage />;
        }
        return (
            <div className={"login-window-" + window.globalConfig.CustomerName} id="loginPage" >
                {this.props.fetching && <Loading />}
                <div className="login-area rounded login-redirect-area">
                    <div className="login-column w-100">
                        <p><img src={this.state.portallogo} /></p>
                        <div className="login-ftr mt-5">
                            <p>{this.props.t('loginRedirect.infoText')}</p>
                        </div>
                        <p style={{ color: "red" }}>{this.state.error}</p>
                        {
                            this.state.error != "" ?
                                <p className="fnt-14"><Link className="vippsbtn mt-2 d-block" to="/"> {this.props.t('login.backLink')} </Link></p>
                                : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    userinformation: state.user.userInfo,
    fetching: state.user.fetching,
    error: state.error.isError
})

const mapDispatchToProps = {
    bankdIdUserInfo,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(BankIdLoginRedirect)));